import * as authService from './service/auth.service';

const state = {
	status: 'authenticating', // 'authenticated','not-authenticated','authenticating'
	user: null,
	token: null,
	modules: [],
	activities: [],
	// Backup de los datos originales para restaurar al salir de un plan type
	_allModules: [],
	_allActivities: [],
	flag_password_reset: false,
};

const mutations = {
	LOGIN_USER(state, { user, token }) {
		if (token) {
			localStorage.setItem('token', token);
			state.token = token;
		}

		state.user = user;
		state.status = 'authenticated';
	},

	LOGOUT(state) {
		state.user = null;
		state.token = null;
		state.status = 'not-authenticated';
		state.modules = [];
		state.activities = [];
		state._allModules = [];
		state._allActivities = [];

		localStorage.removeItem('token');
		localStorage.removeItem('company_id');
	},

	SET_FLAG_PASSWORD_RESET(state, payload) {
		state.flag_password_reset = payload;
	},

	SET_MODULES(state, { user, company_id }) {
		const companies = user?.companies || [];
		let company = null;
		let modules = [];
		let access = [];
		if (Array.isArray(companies)) {
			company = companies.find((company) => company.id == company_id);
		}
		if (Array.isArray(company?.profiles)) {
			company.profiles.forEach((profiles) => {
				profiles.modules.forEach((module) => {
					modules.push(module);
					module.pages.forEach((page) => {
						page.activities.forEach((activity) => {
							access.push({
								module_name: module?.name,
								page_name: page?.name,
								activity_name: activity?.name,
							});
						});
					});
				});
			});
		}
		state.modules = modules;
		state.activities = access;
		// Guardar backup de los datos completos
		state._allModules = [...modules];
		state._allActivities = [...access];
	},

	// Filtra activities para mostrar solo las que corresponden al plan type seleccionado
	SET_MODULES_BY_PLAN_TYPE(state, { planTypeProfiles }) {
		// Restaurar desde backup primero
		state.modules = [...state._allModules];
		state.activities = [...state._allActivities];

		if (!planTypeProfiles || planTypeProfiles.length === 0) return;

		// Obtener IDs de profiles permitidos para este plan type
		const allowedProfileIds = planTypeProfiles.map(p => p.profile?.id || p.profile_id);

		const companies = state.user?.companies || [];
		const company_id = localStorage.getItem('company_id');
		const company = companies.find((c) => c.id == company_id);

		if (!company || !Array.isArray(company.profiles)) return;

		// Filtrar solo los profiles que pertenecen a este plan type
		let modules = [];
		let access = [];
		company.profiles
			.filter((profile) => allowedProfileIds.includes(profile.role.id))
			.forEach((profile) => {
				profile.modules.forEach((module) => {
					modules.push(module);
					module.pages.forEach((page) => {
						page.activities.forEach((activity) => {
							access.push({
								module_name: module?.name,
								page_name: page?.name,
								activity_name: activity?.name,
							});
						});
					});
				});
			});

		state.modules = modules;
		state.activities = access;
	},

	// Restaura activities originales (todas las de la empresa)
	RESTORE_ALL_MODULES(state) {
		state.modules = [...state._allModules];
		state.activities = [...state._allActivities];
	},
};

const actions = {
	async setSession({ commit }, data = null) {
		await commit('LOGIN_USER', { user: data.email, token: data.token });
		return { ok: true, message: null };
	},
	async signInUser({ commit }, user = null) {
		try {
		
			const { email, accessToken } = await authService.login(user);
			const userDetail = { email };

			await commit('LOGIN_USER', { user: userDetail, token: accessToken });
			return { ok: true, message: null };
		} catch (error) {
			return { ok: false, message: error?.response?.data?.message };
		}
	},

	async checkAuthentication({ commit }) {
		const token = localStorage.getItem('token');
		let company_id = localStorage.getItem('company_id');

		if (!token) {
			commit('LOGOUT');
			return { ok: false, message: 'No hay token' };
		}

		try {
			const { user } = await authService.getProfile();

			if (Array.isArray(user?.companies)) {
				const found = user.companies.find(
					(company) => company.id == parseInt(company_id)
				);
				if (!found) {
					localStorage.setItem('company_id', user.companies[0]?.id);
					company_id = user.companies[0]?.id;
				}
			}

			commit('LOGIN_USER', { user, token });
			commit('SET_MODULES', { user, company_id });
			commit('SET_FLAG_PASSWORD_RESET', user?.flag_password_reset || false);

			return { ok: true };
		} catch (error) {
			commit('LOGOUT');
			return { ok: false, message: error.response?.data?.message };
		}
	},

	// Filtra módulos/activities según los profiles del plan type
	filterModulesByPlanType({ commit }, planType) {
		if (!planType?.profiles) return;
		commit('SET_MODULES_BY_PLAN_TYPE', { planTypeProfiles: planType.profiles });
	},

	// Restaura módulos/activities originales (todas los de la empresa)
	restoreAllModules({ commit }) {
		commit('RESTORE_ALL_MODULES');
	},

	async passwordRecovery(context, payload = null) {
		try {
			const data = await authService.passwordRecovery(payload);
			return { ok: true, message: data?.message };
		} catch (error) {
			return { ok: false, message: error?.response?.data?.message };
		}
	},

	async passwordRecoveryToken(context, payload = null) {
		try {
			await authService.passwordRecoveryToken(payload);
			return { ok: true, message: true };
		} catch (error) {
			return { ok: false, message: error?.response?.data?.message };
		}
	},

	async passwordUpdateRecovery(context, payload = null) {
		try {
			await authService.passwordUpdateRecovery(payload);
			return { ok: true, message: true };
		} catch (error) {
			return { ok: false, message: error?.response?.data?.message };
		}
	},

	//passwordRecovery

	logout({ commit }) {
		commit('LOGOUT');
	},

	checkAccess() {},
};

const getters = {
	getCompanies: (state) => {
		let companies = state?.user?.companies || [];
		if (Array.isArray(companies)) {
			companies = companies.map((company) => {
				return { id: company.id, name: company.name };
			});
		}
		return companies;
	},
	hasActivity: (state) => (module, page, activity) => {
		const activities = state?.activities || [];
		const found = activities.some(
			(item) =>
				item.module_name == module &&
				item.page_name == page &&
				item.activity_name == activity
		);
		return found;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
